<template>
  <div>
    <b-button variant="outline-success" v-b-modal.modal-prevent-closing
      >Добавити карту / разове</b-button
    >
    <br /><br />

    <b-modal
      size="lg"
      centered
      id="modal-prevent-closing"
      ref="modal"
      title="Створення карти"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Назва"
          label-for="name-input"
          invalid-feedback="Додайте ім'я"
          :state="nameState"
        >
          <b-form-input
            id="name-input"
            v-model="card.name"
            :state="nameState"
            required
            :class="{
              'is-invalid': $v.card.name.$error && $v.card.name.$dirty,
            }"
            @blur="$v.card.name.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Ціна"
          label-for="cost-input"
          invalid-feedback="Додайте ціну"
          :state="nameState"
        >
          <b-form-input
            id="cost-input"
            type="number"
            v-model="card.cost"
            :state="nameState"
            required
            :class="{
              'is-invalid': $v.card.cost.$error && $v.card.cost.$dirty,
            }"
            @blur="$v.card.cost.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-checkbox
          id="unlim-check"
          v-if="complex"
          class="mt-2"
          v-model="card.unlimited"
        >
          <span v-if="complex">Безліміт</span>
        </b-form-checkbox>
        <b-form-group
          class="mt-2"
          v-if="!card.unlimited"
          id="trainings-helper"
          label="Кількість тренуваннь"
          label-for="trainings-input"
          invalid-feedback="Додайте кількість тренуваннь"
          :state="nameState"
        >
          <b-form-input
            id="trainings-input"
            type="number"
            v-model="card.trainings"
            :state="nameState"
            required
            :class="{
              'is-invalid':
                $v.card.trainings.$error && $v.card.trainings.$dirty,
            }"
            @blur="$v.card.trainings.$touch()"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="validity-helper"
          label="Строк дії (місяці)"
          label-for="validity-input"
          invalid-feedback="Додайте строк дії!"
          :state="nameState"
        >
          <b-form-input
            id="validity-input"
            type="number"
            v-model="card.validity"
            :state="nameState"
            :class="{
              'is-invalid': $v.card.validity.$error && $v.card.validity.$dirty,
            }"
            @blur="$v.card.validity.$touch()"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Тип послуги : "
          v-slot="{ ariaDescribedby }"
          invalid-feedback="Оберіть тип послуги!"
        >
          <b-form-radio-group
            v-model="complex"
            :options="planOptions"
            :aria-describedby="ariaDescribedby"
            name="radio-inline"
          >
            <!--            :class="{'is-invalid': $v.complex.$error&&$v.complex.$dirty}"-->
            <!--            @blur="$v.complex.$touch()"-->
          </b-form-radio-group>
        </b-form-group>
        <b-form-group
          label="Тип тренування"
          label-for="type-input"
          invalid-feedback="Оберіть тип"
          :state="nameState"
        >
          <b-form-select
            id="gender-input"
            v-model="card.training_type"
            :options="options"
            :class="{
              'is-invalid':
                $v.card.training_type.$error && $v.card.training_type.$dirty,
            }"
            @blur="$v.card.training_type.$touch()"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >Оберіть тип тренування</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
        <b-form-group
          v-if="card.training_type === 2"
          label="Групи"
          invalid-feedback="Вкажіть групи"
          :state="nameState"
        >
          <b-form-select
            style="width: 400px; height: 160px"
            size="lg"
            v-model="card.groups"
            :options="groupOptions()"
            multiple
            :select-size="4"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group :state="nameState">
          <b-form-textarea
            v-model="card.description"
            class="mt-3"
            placeholder="Опис"
          ></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import { required } from "vuelidate/lib/validators";

export default {
  name: "CardCreator",
  data: function () {
    return {
      card: {
        name: null,
        trainings: null,
        validity: null,
        training_type: null,
        cost: null,
        groups: [],
        description: null,
        unlimited: false,
      },
      complex: true,
      nameState: null,
      options: [
        { value: 1, text: "Персональні" },
        { value: 2, text: "Групові" },
        { value: 3, text: "Зал" },
        { value: 4, text: "Масаж" },
      ],
      planOptions: [
        { value: true, text: "Абонемент" },
        { value: false, text: "Разовий" },
      ],
    };
  },
  validations() {
    if (
      (this.complex && !this.card.unlimited) ||
      (this.complex === null && !this.card.unlimited)
    ) {
      return {
        card: {
          name: {
            required,
          },
          trainings: {
            required,
          },
          validity: {
            required,
          },
          training_type: {
            required,
          },
          cost: {
            required,
          },
        },
      };
    } else if (this.card.unlimited) {
      return {
        card: {
          name: {
            required,
          },
          validity: {
            required,
          },
          training_type: {
            required,
          },
          cost: {
            required,
          },
        },
      };
    } else if (!this.complex) {
      return {
        card: {
          name: {
            required,
          },
          training_type: {
            required,
          },
          cost: {
            required,
          },
        },
      };
    }
  },
  watch: {
    complex: function (value) {
      console.log(this.complex);
      if (value === false) {
        document.getElementById("trainings-input").style.display = "none";
        document.getElementById("trainings-helper").style.display = "none";
        document.getElementById("validity-input").style.display = "none";
        document.getElementById("validity-helper").style.display = "none";
        document.getElementById("unlim-check").style.display = "none";
      } else if (value === true) {
        document.getElementById("trainings-input").style.display = "block";
        document.getElementById("validity-input").style.display = "block";
        document.getElementById("validity-helper").style.display = "block";
        document.getElementById("trainings-helper").style.display = "block";
        document.getElementById("unlim-check").style.display = "block";
      }
    },
  },
  computed: {
    ...mapState(["schedule"]),
  },
  methods: {
    ...mapActions(["createCard"]),
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    groupOptions() {
      let options = [];
      this.schedule.forEach((training) => {
        options.push({
          value: training.id,
          text:
            training.name +
            " " +
            training.daytime +
            `(Атом ${training.club_id})`,
        });
      });
      return options;
    },
    resetModal() {
      for (let field in this.card) {
        this.card[`${field}`] = null;
      }
      this.complex = true;
      this.$v.card.$reset();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log(this.card.unlimited);
        return;
      }
      let card = this.card;
      if (this.complex === true) {
        await this.createCard({ card });
        this.$emit("refresh-list", "success");
      } else if (this.complex === false) {
        await axios.post(
          `${process.env.VUE_APP_API}/solotrainings/create`,
          {
            name: this.card.name,
            cost: this.card.cost,
            training_type: this.card.training_type,
            allowed_groups: this.card.groups,
            description: this.card.description,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get("access_token")}`,
            },
          },
        );
      }
      this.$emit("refresh-list", "success");

      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
  },
};
</script>

<style scoped></style>
